import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { HeimdallRepository } from '../domain/heimdall.repository'

type ResponseOfflineParticipant = {
  success: boolean
  message: string
  data: {}
}

export const odinHeimdallRepository: HeimdallRepository = {
  setOfflineParticipant: async (jobUuid: string, currentUserId: string) => {
    const request: HttpRequest = {
      method: 'PUT',
      endpoint: `/heimdall/api/job-inbox/${jobUuid}/participants/${currentUserId}/offline`
    }

    const response = await AvtGateway.executePutRequest<ResponseOfflineParticipant>({
      ...request
    })

    return response.success
  }
}
